module.exports = __webpack_public_path__ + "static/img/home1.8e58e8e6.png";